import React, { createContext, useContext, useState, ReactNode } from "react";
import { ThemeIconEnum } from "../Components/UI/Themes/ThemeEnums";

export interface FabConfig {
  icon: ThemeIconEnum;
  label: string;
  onClick: () => void;
}

interface FabContextType {
  fab: FabConfig | null;
  setFab: (fab: FabConfig | null) => void;
}

const FabContext = createContext<FabContextType | null>(null);

export const FabProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [fab, setFab] = useState<FabConfig | null>(null);

  return <FabContext.Provider value={{ fab, setFab }}>{children}</FabContext.Provider>;
};

export const useFab = () => {
  const context = useContext(FabContext);
  if (!context) {
    throw new Error("useFab must be used within FabProvider");
  }
  return context;
};
